/**
 * Created by zoechodosh on 3/15/17.
 */
export const chunkArray = (arr, chunkSize) => { //eslint-disable-line
  const returnArray = [];
  let i = 0;
  for (i; i < arr.length; i += chunkSize) {
    returnArray.push(arr.slice(i, i + chunkSize));
  }
  return returnArray;
};



/** WEBPACK FOOTER **
 ** ./src/components/common/ui/templateHelpers.js
 **/